export { default } from './PatientDetails';
